export const clearObj = (o: object) => {
    Object.keys(o).forEach(k => {
        delete o[k];
    });
}

export function stringifyProps(object: object, props: string[], deleteEmptyStrings=true) {
  props.forEach(p => {
    if(object[p] && typeof object[p] === "object") {
      object[p]  = JSON.stringify(object[p]);
    }
  });
  return object;
}

export function isNullOrUndefined(value: any) {
  return value === undefined || value === null;
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noop = (...args: any[]) => {};

export function tryParseProps(object: object, props: string[], deleteEmptyStrings=true) {
  props.forEach(p => {
    if(p in object && typeof object[p] === "string") {
      if (object[p] === "") {
        if (deleteEmptyStrings) {
          delete object[p];
        }
        return;
      }
      object[p]  = JSON.parse(object[p]);
    }
    if(deleteEmptyStrings && object[p] === "") {
      delete object[p]
    }
  });
  return object;
}

export function adjustedRetryTimeout(retry, minTimeout, maxRetry, maxTimeout) : number {
    if (retry >= maxRetry) {
        return maxTimeout;
      } else {
        const percentage = retry / maxRetry;
        return minTimeout + percentage * (maxTimeout - minTimeout);
      }
  }

  export function makeId(length: number) : string {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
}

export function isConstructor(f: any) {
  return !!f && !!f.prototype && !!f.prototype.constructor?.name;
}

export function isFunction(f: any) {
  return typeof f === 'function';
}

export const removeFromArray = (array: Array<any>, item: any) => {
  for(let i = 0; i < array.length; i++) {
    if(array[i] === item) {
      array.splice(i, 1);
      return true;
    }
  } 
  return false;
}

export function tryParse(data: string) {
  try {
      return JSON.parse(data);
  } catch(err) {
      return data;
  }
}


export async function invokeOrReturn(v: ((...args: any[]) => Promise<any>) | any,  ...args: any[]): Promise<any> {
  return typeof v === "function" ?  await  v(...args) : v;
}

export const asyncTimeout = (ts: number) => {
  return new Promise((resolve) => {
      setTimeout(() => {
          return resolve(true);
      }, ts);
  })
}


export function safeMerge(obj1?: any, obj2?: any) : any {
  if(obj1 && typeof obj1 === 'object' && obj2 && typeof obj2 === 'object') {
    return {
      ...obj1,
      ...obj2
    }
  }
  if(obj1 && typeof obj1 === 'object') {
    return {
      ...obj1
    }
  }
  if(obj2 && typeof obj2 === 'object') {
    return {
      ...obj2
    }
  }
  return {};
}

export function overrideFunction(object: any, functionName: string, functionOrStringToEval: string | ((...args: any[]) => any)): void {
  if (typeof functionOrStringToEval === 'string') {
    object[functionName] = new Function(functionOrStringToEval).bind(object);
  } else if (typeof functionOrStringToEval === 'function') {
    object[functionName] = functionOrStringToEval.bind(object);
  } else {
    throw new Error(`Invalid input for ${functionName}: must be a string or a function.`);
  }
}


export const secondsToMs = (s: number) => s * 1000
export const minutesToMs = (m: number) => secondsToMs(m * 60)
export const hoursToMs = (h: number) => minutesToMs(h * 60)


export function debounce(fn: (...args: any[]) => void, delay: number) {
  let timeout: ReturnType<typeof setTimeout> | null = null;
  return (...args: any[]) => {
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => fn(...args), delay);
  };
}